export default __webpack_public_path__ + "static/media/shoppingcart-2-1.e4b8e9da.svg";